
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/makeup-recommendations/eyeliner",
      function () {
        return require("private-next-pages/makeup-recommendations/eyeliner.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/makeup-recommendations/eyeliner"])
      });
    }
  